module.exports = __webpack_public_path__ + "img/saco-de-dinheiro.021351a2.svg";